// ** 3rd Party Library
import { PortableText } from "@portabletext/react"
import { GatsbyImage } from "gatsby-plugin-image"
import { classNames, columnSpan } from "../../../utils/helpers"

// ** Custom Components
import Container from "../../Container"
import SectionProfileCard from "../../SectionProfileCard"
import { serializers } from "../../Serializers"
import Box from "../../Box"
import Button from "../../Button"
import SectionLink from "../../SectionLink"

const SectionContent = ({ section }: any) => {
  const {
    _rawContent: content,
    media,
    mediaPosition,
    tags,
    linkPrimary,
  } = section
  const rounded = tags?.includes("rounded")
  const gray = tags?.includes("gray")
  const pair = tags?.includes("pair")
  const fullBackground = tags?.includes("full-background")
  const bigTopPadding = tags?.includes("big-top-padding")
  const heroTopPadding = tags?.includes("hero-top-padding")
  const titleCenter = tags.includes("title-align-center")
  const image_desktop = media?.image_desktop ? media.image_desktop : null
  const image_mobile = media?.image_mobile ? media.image_mobile : null

  const span = columnSpan(tags)

  if (tags.includes("profile-card")) {
    return <SectionProfileCard section={section} />
  } else {
    return (
      <Container
        fullWidthOnMobile={false}
        constrainedToBreakPoint
        className={classNames(
          fullBackground && "min-h-[500px]",
          bigTopPadding && "md:mt-14",
          heroTopPadding && "pt-10",
          rounded && !pair && "!px-0",
          rounded && pair
            ? "flex flex-col justify-center items-center h-full p-4"
            : "text-center lg:text-left",
          gray && "bg-gray-200"
        )}
      >
        <Box
          className={classNames(
            image_desktop && "flex flex-col lg:flex-row gap-10",
            mediaPosition === "right" && "lg:flex-row-reverse",
            fullBackground &&
              mediaPosition === "right" &&
              "relative flex-col-reverse h-ful",
            rounded &&
              !pair &&
              "mx-4 rounded-[20px] overflow-hidden isolate shadow-md text-center",
            rounded && pair && "flex flex-col lg:flex-row text-center"
          )}
        >
          {image_desktop && (
            <Box
              className={classNames(
                image_mobile && "hidden lg:flex",
                image_desktop && span === "equal" && !rounded
                  ? "lg:w-1/2"
                  : image_desktop && span === "wider-left"
                  ? "lg:flex-1"
                  : rounded
                  ? "w-full lg:w-1/2"
                  : "lg:w-full",
                "flex flex-col justify-center"
              )}
            >
              <GatsbyImage
                image={image_desktop?.asset?.gatsbyImageData}
                alt={image_desktop?.asset?.altText || "content"}
                className={
                  fullBackground
                    ? "!absolute top-16 lg:top-10 left-0 w-full pointer-events-none"
                    : ""
                }
              />
            </Box>
          )}
          {image_mobile && (
            <Box
              className={classNames(image_desktop && "flex flex-col lg:hidden")}
            >
              <GatsbyImage
                image={image_mobile?.asset?.gatsbyImageData}
                alt={image_mobile?.asset?.altText || "content"}
                className="max-w-[350px] mx-auto"
              />
            </Box>
          )}
          <Box
            className={classNames(
              image_desktop && span === "equal"
                ? "lg:w-1/2"
                : image_desktop && span === "wider-left"
                ? "lg:basis-4/12"
                : "lg:w-full",
              image_desktop && rounded
                ? "px-4 max-w-[420px] m-auto"
                : rounded && pair
                ? "max-w-[420px]"
                : image_desktop && "[&>p]:lg:mt-8 py-8",
              "flex flex-col justify-center [&>h4]:font-extrabold [&>p]:mt-4",
              titleCenter &&
                "[&>h2]:text-center [&>h6]:text-left [&>p]:text-left"
            )}
          >
            <PortableText value={content} components={serializers} />
            {linkPrimary && (
              <SectionLink link={linkPrimary}>
                <Button className="bg-orange-500 max-w-max text-white py-4 px-8 lg:fluid-lg mt-4">
                  {linkPrimary?.title}
                </Button>
              </SectionLink>
            )}
          </Box>
        </Box>
      </Container>
    )
  }
}

export default SectionContent
